import { render, staticRenderFns } from "./AbuseFilteredIps.vue?vue&type=template&id=0b5a8f40"
import script from "./AbuseFilteredIps.vue?vue&type=script&lang=js"
export * from "./AbuseFilteredIps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports